import React from 'react';
import styled from 'styled-components';

import monthIcon from '../../svg/calendar.svg';
import caretIcon from '../../svg/caret.svg';

import { months, groupByKey } from '../../helpers';
import { report } from '../../services/api';
import MonthMenuYear from './MonthMenuYear';

const Container = styled.div`
  display: inline-block;
  position: relative;
  padding-top: -10px;
  vertical-align: middle;
  padding-right: 10px;
  margin-top: -2px;
`;

const Picker = styled.div`
  z-index: 1000;
  margin-top: 15px;
  position: absolute;
  top: 45px;
  max-height: 400px;
  overflow-y: scroll;
`;

interface Props {
  dates: MonthlyReportDate;
  loadDate: any;
}

interface State {
  showMenu: boolean;
  months: { [year: string]: Array<MonthlyReportDate> };
}

class MonthMenu extends React.Component<Props, State> {
  state: State = { showMenu: false, months: {} };

  constructor(props: Props) {
    super(props);
    report.monthList().then((data: any) => {
      if (data.length === 0) {
        alert('No data');
      }
      const months = groupByKey<MonthlyReportDate>(data as Array<MonthlyReportDate>, 'year');
      this.setState({ months });
      const current = months[Math.max.apply(null, Object.keys(months) as any)];
      if (!props.dates.year) this.props.loadDate(current[current.length - 1]);
    });
  }

  openMenu() {
    this.setState((prev) => ({ showMenu: !prev.showMenu }));
  }

  load(date: MonthlyReportDate) {
    this.props.loadDate(date);
    this.openMenu();
  }

  render() {
    return (
      <Container>
        <div className="date-item" onClick={() => this.openMenu()} role="button">
          <img className="no-print" src={monthIcon} />
          <div className="menu-text color-greyish-brown">
            {this.props.dates.year
              ? `${months[this.props.dates.month - 1]} ${this.props.dates.year}`
              : ''}
          </div>
          <img
            className="no-print"
            style={{ paddingLeft: '65px', width: 'auto', float: 'right', marginTop: '17px' }}
            src={caretIcon}
          />
          <br />
        </div>
        {this.state.showMenu ? (
          <Picker>
            {Object.keys(this.state.months)
              .sort()
              .reverse()
              .map((year, i) => (
                <MonthMenuYear
                  load={(date) => this.load(date)}
                  year={year}
                  months={this.state.months[year]}
                  open={i === 0}
                />
              ))}
          </Picker>
        ) : null}
      </Container>
    );
  }
}

export default MonthMenu;
